import * as Bie from "./brands-individual-editor"
import {Emit_main} from "../navigation"

export default function Create_brand() {
    return (<Emit_main page_id="PAGE-brands"><Bie.Brand_editor brand_id={{tag : "create-brand"}}/></Emit_main>)
}
